import React, { useState } from 'react';
import { Box, Typography, TextField } from '@mui/material';
import AddressAutocomplete from './AddressAutocomplete.jsx';

const NearestPharmacy = () => {
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [pharmacies, setPharmacies] = useState([]);
  const [address, setAddress] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const handlePlaceSelect = (place) => {
    setSelectedPlace(place);
    // Use place.geometry.location to find nearby pharmacies
    // Fetch and set pharmacies based on the selected location
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = {
      address,
      name,
      email,
      phone
    };

    try {
      // const response = await axios.post(, data);
      // setMessage(response.data.CustomerMessage);
      // setError(null);
    } catch (error) {
      // setMessage(null);
      // setError(error.response ? error.response.data.errorMessage : 'An error occurred');
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <AddressAutocomplete onPlaceSelect={handlePlaceSelect} />
        <TextField
          label='Enter your Name'
          variant='outlined'
          fullWidth
          value={name}
          required
          placeholder='Enter your Name'
          onChange={(e) => setName(e.target.value)}
          sx={{ marginTop: '1rem' }}
        />
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2, marginTop: '1rem' }}>
          <TextField
            label='Email'
            variant='outlined'
            fullWidth
            value={email}
            required
            placeholder='Email'
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label='Phone Number / Delivery Number'
            variant='outlined'
            fullWidth
            value={phone}
            required
            placeholder='Phone Number / Delivery Number'
            onChange={(e) => setPhone(e.target.value)}
          />
        </Box>
        <Typography variant='h6' mt='2rem'>Nearby Pharmacies</Typography>
        <ul>
          {pharmacies.map((pharmacy, index) => (
            <li key={index}>{pharmacy.name}</li>
          ))}
        </ul>
      </form>
    </Box>
  );
};

export default NearestPharmacy;
